<template>
  <div class="category-section">
    
    <div class="metric-container">
      <div class="category-header" :class="{ highlight: highlightHeader }">
        <h3>{{ title }}</h3>
      </div>
      <div class="metric" v-for="(item, index) in metrics" :key="index">
       
        <div class="label-value">
          <div class="metric-label">{{ item.label }}</div>
          <div class="metric-value push">{{ item.value }}</div>
        </div>
        <div class="metric-bar">
          <div
            class="metric-progress"
            :style="{ width: item.value * 5 + '%' }"
          ></div>
        </div>
       
      </div>
    </div> 
    
  </div>
  

</template>

<script>
export default {
  props: {
    title: String,
    metrics: Array,
    highlightHeader: Boolean, // New prop
  },
};
</script>


<style scoped>
.category-section {
  /* display: flex;
  align-items: flex-end; */
  text-align: left;
  background: #f9f9f9;
  text-align: left;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.category-header {
  /* color: #fe918b; */
  border-radius: 8px 0 0 8px;
  font-weight: bold;
  text-align: left;
  font-size: clamp(16px, 5vw, 22px);
  margin-bottom: 1rem;
 
}

.category-header.highlight {
  background-color: #ff6860;
  color: white;
}

.metric-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  padding: 2rem;
  gap: 12px;
}


.label-value{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

}
.push{
  margin-left: auto;
}
.metric-label {
  flex: 2;
  font-size: 14px;
  color: #333;
  height: 100%;
  min-width: 150px;
}

.metric-bar {
  background: #f0e6e6;
  flex: 4; 
  
  height: 15px;
  margin: 10px 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-width: 100px;
}

.metric-progress {
  background: #fe716a;
  height: 100%;
  border-radius: 0;
  transition: width 2s ease-out;
}

.metric-value {
  flex: 0 0 20px; 
  font-size: 14px;
  font-weight: 700;
  color: #fe716a;
  /* text-align: left; */
}

@media screen and (max-width: 1068px) {
  .category-header {
    width: 100%;
    border-radius: 8px 8px 0px 0px;
  }
  .category-section {
    display: grid;
    background: #f9f9f9;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    gap: 5px;
  }
}

@media screen and (max-width: 774px) {
  .category-section {
    align-content: space-around;
  }
  .metric-container {
    padding: 10px;
  }
}
</style>